module.exports = __webpack_public_path__ + "img/Fabric.0689a05c.jpg";